<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
        <div class="list-page-heading-main">
          <h1 class="list-page-title">待办事项</h1>
          <p class="list-page-description">管理您的工作任务和待办事项</p>
        </div>
        <div class="flex flex-wrap items-center gap-3">
          <button
            @click="showCreateModal = true"
            class="btn-primary inline-flex items-center gap-2"
          >
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            新建待办
          </button>
        </div>
      </div>
      </div>

      <!-- 筛选栏 -->
    </template>

    <template #filters>
    <PageFilterBar
      :show-refresh="true"
      :refresh-loading="loading"
      @refresh="fetchData"
    >
        <!-- 搜索框 -->
        <div class="relative flex-1 min-w-[200px]">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input
            v-model="searchKeyword"
            type="text"
            placeholder="搜索待办事项..."
            class="form-search-input form-control-sm w-full"
            @keyup.enter="handleSearch"
          />
        </div>

        <!-- 优先级筛选 -->
        <select
          v-model="filterPriority"
          class="form-select-native form-control-sm"
          @change="handleFilterChange"
        >
          <option value="">全部优先级</option>
          <option :value="1">低</option>
          <option :value="2">中</option>
          <option :value="3">高</option>
          <option :value="4">紧急</option>
        </select>

      <template #actions>
        <div class="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
          <button
            @click="viewMode = 'list'"
            :class="[
              'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              viewMode === 'list' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'
            ]"
          >
            <svg class="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
            </svg>
          </button>
          <button
            @click="viewMode = 'kanban'"
            :class="[
              'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              viewMode === 'kanban' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'
            ]"
          >
            <svg class="w-4 h-4 inline" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7"/>
            </svg>
          </button>
        </div>
      </template>

      <template #searchActions>
        <button
          type="button"
          @click="handleSearch"
          class="btn-primary inline-flex items-center gap-2"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          搜索
        </button>
        <button
          type="button"
          @click="handleReset"
          class="btn-secondary"
        >
          重置
        </button>
      </template>
    </PageFilterBar>
    </template>

    <!-- 批量操作栏 -->
    <div v-if="selectedIds.length > 0" class="bg-primary-50 border border-primary-200 rounded-xl p-3 mb-6">
      <div class="flex items-center justify-between">
        <span class="text-sm text-primary-700">已选择 <strong>{{ selectedIds.length }}</strong> 项</span>
        <div class="flex items-center gap-2">
          <button
            @click="batchComplete"
            class="px-3 py-1.5 text-sm text-green-700 bg-green-100 rounded-lg hover:bg-green-200 transition-colors"
          >
            批量完成
          </button>
          <button
            @click="batchDelete"
            class="px-3 py-1.5 text-sm text-red-700 bg-red-100 rounded-lg hover:bg-red-200 transition-colors"
          >
            批量删除
          </button>
          <button
            @click="clearSelection"
            class="px-3 py-1.5 text-sm text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
          >
            取消选择
          </button>
        </div>
      </div>
    </div>

    <!-- 列表视图 -->
    <div v-if="viewMode === 'list'" class="list-page-table-panel">
      <div class="data-table-shell">
        <div class="data-table-scroll">
          <table class="data-table text-sm">
            <thead class="data-table-head">
              <tr>
                <th class="data-table-th text-left" style="width: 40px;">
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    :indeterminate="selectedIds.length > 0 && selectedIds.length < listData.length"
                    @change="toggleSelectAll"
                    class="form-check"
                  />
                </th>
                <th class="data-table-th text-left">待办事项</th>
                <th class="data-table-th text-left" style="width: 100px;">优先级</th>
                <th class="data-table-th text-left" style="width: 120px;">到期时间</th>
                <th class="data-table-th text-left" style="width: 90px;">状态</th>
                <th class="data-table-th text-center" style="width: 120px;">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in listData"
                :key="item.id"
                class="data-table-row"
              >
                <td class="data-table-td whitespace-nowrap">
                  <input
                    type="checkbox"
                    :checked="selectedIds.includes(item.id)"
                    @change="toggleSelect(item.id)"
                    class="form-check"
                  />
                </td>
                <td class="data-table-td">
                  <div class="flex items-start gap-3">
                    <button
                      @click="toggleItemComplete(item)"
                      :disabled="item.status === 'COMPLETED' || item.status === 'cancelled'"
                      :class="[
                        'w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors mt-0.5',
                        item.status === 'COMPLETED'
                          ? 'bg-green-500 border-green-500 text-white'
                          : 'border-slate-300 hover:border-primary-500 cursor-pointer'
                      ]"
                    >
                      <svg v-if="item.status === 'COMPLETED'" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"/>
                      </svg>
                    </button>
                    <div class="flex-1 min-w-0 cursor-pointer" @click="openDetail(item)">
                      <div class="flex items-start gap-2">
                        <p :class="['text-sm font-medium break-all', getTitleClass(item)]">{{ item.title }}</p>
                        <span v-if="item.overdue" class="px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full shrink-0 mt-0.5">逾期</span>
                      </div>
                      <p v-if="item.description" class="text-xs text-slate-500 mt-0.5 line-clamp-3 break-all">{{ item.description }}</p>
                    </div>
                  </div>
                </td>
                <td class="data-table-td whitespace-nowrap">
                  <span :class="getPriorityBadgeClass(item.priority)">{{ item.priorityDesc || getPriorityLabel(item.priority) }}</span>
                </td>
                <td class="data-table-td whitespace-nowrap">
                  <span :class="['text-sm', getDueDateClass(item.dueDate, item.overdue)]">
                    {{ formatDate(item.dueDate) }}
                  </span>
                </td>
                <td class="data-table-td whitespace-nowrap">
                  <span
                    :class="[
                      'px-2 py-0.5 text-xs rounded-full font-medium',
                      item.status === 'COMPLETED'
                        ? 'bg-green-100 text-green-700'
                        : item.status === 'cancelled'
                          ? 'bg-slate-100 text-slate-700'
                          : item.overdue
                            ? 'bg-red-100 text-red-700'
                            : item.status === 'IN_PROGRESS'
                              ? 'bg-blue-100 text-blue-700'
                              : 'bg-amber-100 text-amber-700'
                    ]"
                  >
                    {{ item.statusDesc || (item.status === 'COMPLETED' ? '已完成' : item.status === 'cancelled' ? '已取消' : item.overdue ? '已逾期' : item.status === 'IN_PROGRESS' ? '进行中' : '待办') }}
                  </span>
                </td>
                <td class="data-table-td is-center whitespace-nowrap">
                  <div class="flex items-center justify-center gap-1">
                    <button
                      v-if="item.status !== 'COMPLETED'"
                      @click="completeItem(item)"
                      class="table-action-button is-success"
                      title="完成"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    </button>
                    <button
                      @click="openDetail(item)"
                      class="table-action-button is-primary"
                      title="详情"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                      </svg>
                    </button>
                    <button
                      @click="deleteItem(item)"
                      class="table-action-button is-danger"
                      title="删除"
                    >
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 空状态 -->
      <div v-if="listData.length === 0 && !loading" class="flex flex-col items-center justify-center py-16">
        <div class="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-4">
          <svg class="w-10 h-10 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
        </div>
        <p class="text-slate-500 text-sm mb-4">暂无待办事项</p>
        <button
          @click="showCreateModal = true"
          class="btn-primary"
        >
          立即创建
        </button>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="flex items-center justify-center py-12">
        <svg class="w-8 h-8 animate-spin text-primary-500" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      </div>

      <!-- 分页 -->
      <AppPagination
        v-if="pagination.pages > 1"
        class="pagination-bridge"
        :pagination="pagination"
        :page-sizes="[10, 20, 50]"
        :show-page-count="true"
        @page-change="handlePageChange"
        @size-change="handlePageSizeChange"
      />
    </div>

    <!-- 看板视图 -->
    <div v-else class="grid grid-cols-4 gap-4">
      <!-- 待办列 -->
      <div class="bg-slate-100 rounded-xl p-4">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 bg-amber-500 rounded-full"></div>
            <h3 class="font-medium text-slate-700">待办</h3>
            <span class="px-2 py-0.5 bg-slate-200 text-slate-600 text-xs rounded-full">{{ PENDINGList.length }}</span>
          </div>
          <button
            @click="showCreateModal = true"
            class="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded-lg transition-all duration-200 cursor-pointer"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
          </button>
        </div>
        <div class="space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1">
          <div
            v-for="item in PENDINGList"
            :key="item.id"
            class="bg-white rounded-lg border border-slate-200 p-4 hover:shadow-lg hover:border-amber-200 transition-all duration-200 ease-out cursor-pointer group"
            @click="openDetail(item)"
          >
            <div class="flex items-start justify-between mb-2">
              <span :class="getPriorityBadgeClass(item.priority)">{{ item.priorityDesc || getPriorityLabel(item.priority) }}</span>
              <button
                @click.stop="deleteItem(item)"
                class="p-1 text-slate-300 hover:text-red-500 hover:bg-red-50 rounded transition-all duration-200 opacity-0 group-hover:opacity-100"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </button>
            </div>
            <h4 class="text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900">{{ item.title }}</h4>
            <p v-if="item.description" class="text-xs text-slate-500 mb-3 line-clamp-2">{{ item.description }}</p>
            <div class="flex items-center justify-between">
              <span :class="['text-xs', getDueDateClass(item.dueDate, item.overdue)]">
                {{ formatDate(item.dueDate) }}
              </span>
              <button
                @click.stop="completeItem(item)"
                class="p-1.5 text-slate-300 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200"
                title="完成"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-if="PENDINGList.length === 0" class="flex flex-col items-center justify-center py-8 text-slate-400">
            <svg class="w-8 h-8 mb-2 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
            </svg>
            <span class="text-sm">暂无待办</span>
          </div>
        </div>
      </div>

      <!-- 进行中列 -->
      <div class="bg-blue-50 rounded-xl p-4">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 bg-blue-500 rounded-full"></div>
            <h3 class="font-medium text-slate-700">进行中</h3>
            <span class="px-2 py-0.5 bg-blue-200 text-blue-700 text-xs rounded-full">{{ inProgressList.length }}</span>
          </div>
        </div>
        <div class="space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1">
          <div
            v-for="item in inProgressList"
            :key="item.id"
            class="bg-white rounded-lg border border-blue-200 p-4 hover:shadow-lg hover:border-blue-300 transition-all duration-200 ease-out cursor-pointer group"
            @click="openDetail(item)"
          >
            <div class="flex items-start justify-between mb-2">
              <span :class="getPriorityBadgeClass(item.priority)">{{ item.priorityDesc || getPriorityLabel(item.priority) }}</span>
              <button
                @click.stop="completeItem(item)"
                class="p-1.5 text-slate-300 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100"
                title="完成"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              </button>
            </div>
            <h4 class="text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900">{{ item.title }}</h4>
            <p v-if="item.description" class="text-xs text-slate-500 mb-3 line-clamp-2">{{ item.description }}</p>
            <div class="flex items-center justify-between">
              <span :class="['text-xs', getDueDateClass(item.dueDate, item.overdue)]">
                {{ formatDate(item.dueDate) }}
              </span>
            </div>
          </div>
          <div v-if="inProgressList.length === 0" class="flex flex-col items-center justify-center py-8 text-slate-400">
            <svg class="w-8 h-8 mb-2 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 10V3L4 14h7v7l9-11h-7z"/>
            </svg>
            <span class="text-sm">暂无进行中</span>
          </div>
        </div>
      </div>

      <!-- 已完成列 -->
      <div class="bg-gradient-to-b from-green-50 to-green-100 rounded-xl p-4 border-t-2 border-green-300">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 bg-green-500 rounded-full shadow-sm"></div>
            <h3 class="font-semibold text-green-800">已完成</h3>
            <span class="px-2 py-0.5 bg-green-500 text-white text-xs font-medium rounded-full shadow-sm">{{ COMPLETEDList.length }}</span>
          </div>
        </div>
        <div class="space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1">
          <div
            v-for="item in COMPLETEDList"
            :key="item.id"
            class="bg-white rounded-lg border border-green-200 p-4 hover:shadow-lg hover:border-green-400 transition-all duration-200 ease-out cursor-pointer group"
            @click="openDetail(item)"
          >
            <div class="flex items-start justify-between mb-2">
              <span :class="getPriorityBadgeClass(item.priority)">{{ item.priorityDesc || getPriorityLabel(item.priority) }}</span>
              <div class="flex items-center gap-1">
                <span class="px-1.5 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded">已完成</span>
                <svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              </div>
            </div>
            <h4 class="text-sm font-medium text-slate-600 mb-2 line-through decoration-green-400">{{ item.title }}</h4>
            <p v-if="item.description" class="text-xs text-slate-400 mb-3 line-clamp-2">{{ item.description }}</p>
            <div class="flex items-center justify-between">
              <span class="text-xs text-green-600 font-medium">已完成</span>
            </div>
          </div>
          <div v-if="COMPLETEDList.length === 0" class="flex flex-col items-center justify-center py-8 text-green-400">
            <svg class="w-8 h-8 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span class="text-sm font-medium">暂无已完成</span>
          </div>
        </div>
      </div>

      <!-- 已逾期列 -->
      <div class="bg-red-50 rounded-xl p-4">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-3 h-3 bg-red-500 rounded-full"></div>
            <h3 class="font-medium text-slate-700">已逾期</h3>
            <span class="px-2 py-0.5 bg-red-200 text-red-700 text-xs rounded-full">{{ OVERDUEList.length }}</span>
          </div>
        </div>
        <div class="space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1">
          <div
            v-for="item in OVERDUEList"
            :key="item.id"
            class="bg-white rounded-lg border border-red-200 p-4 hover:shadow-lg hover:border-red-300 transition-all duration-200 ease-out cursor-pointer group"
            @click="openDetail(item)"
          >
            <div class="flex items-start justify-between mb-2">
              <span :class="getPriorityBadgeClass(item.priority)">{{ item.priorityDesc || getPriorityLabel(item.priority) }}</span>
              <button
                @click.stop="completeItem(item)"
                class="p-1.5 text-slate-300 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100"
                title="完成"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                </svg>
              </button>
            </div>
            <h4 class="text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900">{{ item.title }}</h4>
            <p v-if="item.description" class="text-xs text-slate-500 mb-3 line-clamp-2">{{ item.description }}</p>
            <div class="flex items-center justify-between">
              <span class="text-xs text-red-600">{{ formatDate(item.dueDate) }}</span>
            </div>
          </div>
          <div v-if="OVERDUEList.length === 0" class="flex flex-col items-center justify-center py-8 text-slate-400">
            <svg class="w-8 h-8 mb-2 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            <span class="text-sm">暂无逾期</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 新建待办弹窗 -->
    <Teleport to="body">
      <Transition name="modal">
        <div
          v-if="showCreateModal"
          class="fixed inset-0 z-50 flex items-center justify-center p-4"
        >
          <div class="absolute inset-0 bg-black/50" @click="closeCreateModal"></div>
          <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-lg mx-4">
            <div class="px-6 py-4 border-b border-slate-200">
              <h3 class="text-lg font-semibold text-slate-900">新建待办</h3>
            </div>
            <div class="p-6 space-y-4">
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">标题 <span class="text-red-500">*</span></label>
                <input
                  v-model="createForm.title"
                  type="text"
                  class="form-input w-full"
                  placeholder="请输入待办标题"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">描述</label>
                <textarea
                  v-model="createForm.description"
                  rows="3"
                  class="form-textarea"
                  placeholder="请输入描述"
                ></textarea>
              </div>
              <div class="grid grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">优先级</label>
                  <select
                    v-model="createForm.priority"
                    class="form-select-native w-full"
                  >
                    <option :value="1">低</option>
                    <option :value="2">中</option>
                    <option :value="3">高</option>
                    <option :value="4">紧急</option>
                  </select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-slate-700 mb-1">到期时间</label>
                  <el-date-picker
                    v-model="createForm.dueDate"
                    type="date"
                    format="YYYY年MM月DD日"
                    value-format="YYYY-MM-DD"
                    placeholder="请选择到期时间"
                    class="w-full"
                  />
                </div>
              </div>
              <div>
                <label class="block text-sm font-medium text-slate-700 mb-1">提醒时间</label>
                <el-date-picker
                  v-model="createForm.reminderTime"
                  type="datetime"
                  format="YYYY年MM月DD日 HH:mm"
                  value-format="YYYY-MM-DDTHH:mm:ss"
                  placeholder="请选择提醒时间"
                  class="w-full"
                />
              </div>
            </div>
            <div class="px-6 py-4 border-t border-slate-200 flex justify-end gap-3">
              <button
                @click="closeCreateModal"
                class="px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
              >
                取消
              </button>
              <button
                @click="handleCreate"
                :disabled="!createForm.title"
                class="px-5 py-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50"
              >
                创建
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>

    <!-- 详情弹窗 -->
    <TodoDetailModal
      :show="showDetailModal"
      :item="currentItem"
      @close="closeDetailModal"
      @complete="onDetailComplete"
    />
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { todoApi } from '@/api/todo'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'
import TodoDetailModal from '@/components/TodoDetailModal.vue'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'

const userStore = useUserStore()

// 视图模式
const viewMode = ref('list')
const searchKeyword = ref('')
const filterPriority = ref('')
const loading = ref(false)

// 数据
const listData = ref([])
const pagination = ref({
  current: 1,
  size: 20,
  total: 0,
  pages: 0
})

// 选中项
const selectedIds = ref([])

// 弹窗状态
const showCreateModal = ref(false)
const showDetailModal = ref(false)
const currentItem = ref(null)

// 创建表单
const createForm = reactive({
  title: '',
  description: '',
  priority: 2,
  dueDate: '',
  reminderTime: ''
})

// 看板列数据
const PENDINGList = computed(() => listData.value.filter(t => t.status === 'PENDING'))
const inProgressList = computed(() => listData.value.filter(t => t.status === 'IN_PROGRESS'))
const COMPLETEDList = computed(() => listData.value.filter(t => t.status === 'COMPLETED'))
const OVERDUEList = computed(() => listData.value.filter(t => t.overdue === true))

// 全选状态
const isAllSelected = computed(() => listData.value.length > 0 && selectedIds.value.length === listData.value.length)

// 优先级映射
const priorityMap = {
  1: { label: '低', class: 'px-2 py-0.5 bg-slate-100 text-slate-700 text-xs rounded-full' },
  2: { label: '中', class: 'px-2 py-0.5 bg-amber-100 text-amber-700 text-xs rounded-full' },
  3: { label: '高', class: 'px-2 py-0.5 bg-orange-100 text-orange-700 text-xs rounded-full' },
  4: { label: '紧急', class: 'px-2 py-0.5 bg-red-100 text-red-700 text-xs rounded-full' }
}

// 获取优先级标签
const getPriorityLabel = (priority) => priorityMap[priority]?.label || priority
const getPriorityBadgeClass = (priority) => priorityMap[priority]?.class || priorityMap[2].class

// 详情弹窗完成回调
const onDetailComplete = () => {
  fetchData()
}

// 获取标题样式
const getTitleClass = (item) => {
  if (item.status === 'COMPLETED') return 'text-slate-400 line-through'
  return 'text-slate-800'
}

// 获取截止日期样式
const getDueDateClass = (date, isOVERDUE) => {
  if (!date) return 'text-slate-500'
  if (isOVERDUE) return 'text-red-600'
  return 'text-slate-600'
}

// 格式化日期
const formatDate = (date) => {
  if (!date) return '未设置'
  const d = new Date(date)
  return `${d.getMonth() + 1}月${d.getDate()}日`
}

// 获取数据
const fetchData = async () => {
  loading.value = true
  try {
    const params = {
      pageNum: pagination.value.current,
      pageSize: pagination.value.size,
      keyword: searchKeyword.value || undefined,
      priority: filterPriority.value || undefined
    }
    // 移除 undefined 值
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) delete params[key]
    })

    const data = await todoApi.getList(params)
    // request 拦截器已处理 code === 0 的情况，data 直接是响应数据
    listData.value = data?.records || []
    pagination.value = {
      current: data?.current || 1,
      size: data?.size || 20,
      total: data?.total || 0,
      pages: data?.pages || 0
    }
  } catch (error) {
    ElMessage.error('获取待办列表失败')
    console.error('获取待办列表失败:', error)
  } finally {
    loading.value = false
  }
}

const handleFilterChange = () => {
  pagination.value.current = 1
  fetchData()
}

const handleSearch = () => {
  pagination.value.current = 1
  fetchData()
}

const handleReset = () => {
  searchKeyword.value = ''
  filterPriority.value = ''
  pagination.value.current = 1
  fetchData()
}

const changePage = (page) => {
  pagination.value.current = page
  fetchData()
}

const handlePageChange = (page) => {
  changePage(page)
}

const handlePageSizeChange = (size) => {
  pagination.value.size = size
  pagination.value.current = 1
  fetchData()
}

// 选择操作
const toggleSelectAll = (e) => {
  if (e.target.checked) {
    selectedIds.value = listData.value.map(t => t.id)
  } else {
    selectedIds.value = []
  }
}

const toggleSelect = (id) => {
  const index = selectedIds.value.indexOf(id)
  if (index > -1) {
    selectedIds.value.splice(index, 1)
  } else {
    selectedIds.value.push(id)
  }
}

const clearSelection = () => {
  selectedIds.value = []
}

// 完成待办
const completeItem = async (item) => {
  try {
    await todoApi.complete(item.id)
    // request 拦截器已处理成功响应，无需检查 code
    ElMessage.success('已完成')
    fetchData()
  } catch (error) {
    ElMessage.error('完成任务失败')
    console.error('完成任务失败:', error)
  }
}

const toggleItemComplete = (item) => {
  if (item.status !== 'COMPLETED') {
    completeItem(item)
  }
}

// 批量完成
const batchComplete = async () => {
  if (selectedIds.value.length === 0) return
  try {
    const count = await todoApi.batchComplete(selectedIds.value)
    ElMessage.success(`已完成 ${count || selectedIds.value.length} 项`)
    clearSelection()
    fetchData()
  } catch (error) {
    ElMessage.error('批量完成失败')
    console.error('批量完成失败:', error)
  }
}

// 删除待办
const deleteItem = async (item) => {
  try {
    await ElMessageBox.confirm('确定要删除该待办吗？', '确认删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await todoApi.batchDelete([item.id])
    ElMessage.success('删除成功')
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败')
      console.error('删除失败:', error)
    }
  }
}

// 批量删除
const batchDelete = async () => {
  if (selectedIds.value.length === 0) return
  try {
    await ElMessageBox.confirm(`确定要删除选中的 ${selectedIds.value.length} 项吗？`, '确认删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    })
    await todoApi.batchDelete(selectedIds.value)
    ElMessage.success(`删除成功`)
    clearSelection()
    fetchData()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('批量删除失败')
      console.error('批量删除失败:', error)
    }
  }
}

// 打开详情
const openDetail = async (item) => {
  try {
    const data = await todoApi.getDetail(item.id)
    currentItem.value = data
    showDetailModal.value = true
  } catch (error) {
    ElMessage.error('获取详情失败')
    console.error('获取详情失败:', error)
  }
}

const closeDetailModal = () => {
  showDetailModal.value = false
  currentItem.value = null
}

// 创建待办
const handleCreate = async () => {
  if (!createForm.title) {
    ElMessage.warning('请输入标题')
    return
  }
  try {
    const data = {
      userId: userStore.userInfo?.id,
      title: createForm.title,
      description: createForm.description,
      priority: createForm.priority,
      dueDate: createForm.dueDate ? `${createForm.dueDate}T23:59:59` : undefined,
      reminderTime: createForm.reminderTime || undefined
    }
    await todoApi.create(data)
    ElMessage.success('创建成功')
    closeCreateModal()
    fetchData()
  } catch (error) {
    ElMessage.error('创建失败')
    console.error('创建失败:', error)
  }
}

const closeCreateModal = () => {
  showCreateModal.value = false
  createForm.title = ''
  createForm.description = ''
  createForm.priority = 2
  createForm.dueDate = ''
  createForm.reminderTime = ''
}

onMounted(() => {
  fetchData()
})
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-active .relative,
.modal-leave-active .relative {
  transition: transform 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .relative,
.modal-leave-to .relative {
  transform: scale(0.95);
}

.overflow-x-auto {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.overflow-x-auto::-webkit-scrollbar {
  height: 6px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
}
</style>
